<div kalDialogContent
     [formGroup]="form"
     [kalLoading]="loading">

    <div class="gup-O-list">
        <div class="gup-O-list__item">
            <kal-form-field>
                <kal-input label="Code Postal"
                           formControlName="postalCode">
                </kal-input>
            </kal-form-field>
        </div>
        <div class="gup-O-list__item gup-U-margin-left--normal">
            <kal-form-field>
                <kal-input label="Code Insee"
                           formControlName="inseeCode">
                </kal-input>
            </kal-form-field>
        </div>
    </div>

    <kal-form-field>
        <kal-input label="Ville"
                   formControlName="cityName">
        </kal-input>
    </kal-form-field>

    <kal-form-field>
        <kal-select formControlName="countryId"
                    placeholder="Sélectionner un pays"
                    label="Pays"
                    displaySearchbar>
            <kal-option *ngFor="let country of countryList"
                        [value]="country.id">
                {{ country.name }}
            </kal-option>
        </kal-select>

        <a class="gup-O-link -secondary" (click)="openCountryAddDialog()">Ajouter un pays</a>
    </kal-form-field>

    <div class="gup-O-list">

        <div class="gup-O-list__item">
            <kal-form-field>
                <kal-input label="Latitude"
                           type="number"
                           formControlName="latitude">
                </kal-input>
            </kal-form-field>
        </div>

        <div class="gup-O-list__item gup-U-margin-left--normal">
            <kal-form-field>
                <kal-input label="Longitude"
                           type="number"
                           formControlName="longitude">
                </kal-input>
            </kal-form-field>
        </div>
    </div>

</div>

<div kalDialogFooter>

    <div class="gup-C-validationArea gup-O-list">

        <div class="gup-O-list__item">

            <kal-button (click)="submit()"
                        [disabled]="form.invalid"
                        kalTheme="primary">
                Ajouter
            </kal-button>

        </div>

        <div class="gup-O-list__item">

            <kal-button (click)="cancel()"
                        kalTheme="secondary">
                Annuler
            </kal-button>

        </div>

    </div>

</div>
